import React, { useState } from "react";

type FormFieldTooltipProps = {
  tooltipText: string;
  tooltipMainIconSource: string;
  tooltipCloseIconSource: string;
};

const FormFieldTooltip: React.FC<FormFieldTooltipProps> = ({
  tooltipText,
  tooltipMainIconSource,
  tooltipCloseIconSource,
}) => {
  const [showTooltipText, setShowTooltipText] = useState<boolean>(false);

  return (
    <div className="FormTooltipContainer">
      <div
        className="TooltipIconContainer"
        onClick={() => setShowTooltipText(!showTooltipText)}
      >
        <img
          src={tooltipMainIconSource}
          alt="Tooltip clickable icon"
          className="TooltipMainIcon"
        />
      </div>

      {showTooltipText && (
        <div className="TooltipTextContainer">
          <img
            src={tooltipCloseIconSource}
            alt="Close tooltip"
            className="TooltipCloseIcon"
            onClick={() => setShowTooltipText(false)}
          />

          <div className="Text">{tooltipText}</div>
        </div>
      )}
    </div>
  );
};

export { FormFieldTooltip };
